<template>
    <chat-message :key="groupedMessage.id" :message="groupedMessage" :frontend="props.frontend"></chat-message>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ChatMessage as ChatMessageType } from '@src/Chat/Pages/types';
import ChatMessage from '@src/Chat/Pages/Chat/ChatMessage.vue';

interface Props {
    group?: ChatMessageType[];
    frontend?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    group: () => [],
    frontend: false,
});

const groupedMessage = computed((): ChatMessageType => {
    const message = props.group.at(-1);

    message.compound = true;
    message.components = props.group.map(({ message }) => message);

    return message;
});
</script>
